import { AuditOutlined } from '@ant-design/icons';
import { Card, Form, Input } from 'antd';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { ICertifiers } from 'interfaces/certifiers';
import { PageHeader } from 'components/professor_area/PageHeader';
import { useForm } from '@refinedev/antd';

export const CertifierEdit = () => {
  const { formProps, saveButtonProps } = useForm<ICertifiers>({
    successNotification: () => ({
      type: 'success',
      description: 'Sucesso!',
      message: 'Instituição certificadora criada com sucesso!'
    })
  });
  return (
    <EditLayout
      saveButtonProps={saveButtonProps}
      title="Editar instituição certificadora"
    >
      <PageHeader
        title={
          formProps?.initialValues?.name || 'Editar instituição certificadora'
        }
        icon={AuditOutlined}
      />

      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Nome da instituição"
            name="name"
            rules={[
              {
                required: true,
                message: 'Nome obrigatório'
              }
            ]}
          >
            <Input style={{ maxWidth: 600 }} />
          </Form.Item>
          <Form.Item
            label="Código"
            name="code"
            rules={[
              {
                required: true,
                message: 'Código obrigatório'
              }
            ]}
          >
            <Input style={{ maxWidth: 200 }} />
          </Form.Item>

          <Form.Item
            label="Credenciamento"
            name="accreditation"
            rules={[{ required: true, message: 'Campo obrigatório' }]}
          >
            <Input.TextArea rows={4} style={{ maxWidth: 600 }} />
          </Form.Item>

          <Form.Item label="Recredenciamento" name="reaccreditation">
            <Input.TextArea rows={4} style={{ maxWidth: 600 }} />
          </Form.Item>
        </Form>
      </Card>
    </EditLayout>
  );
};
